<template>
  <div>
    <h1 class="headline mb-4 pt-4">Punch Dashboard</h1>
    <p>Select the job site you will be punching employees in/out.</p>
    <my-job-sites />
    <h2 class="title mb-4 pt-4">Recent Punches</h2>
    <v-alert dense border="left" type="warning" v-if="showManaulWarning">
      Your punches indicate frequent manual punch in/out of employees. Please
      use your camera. Payroll will be notified to review all manual punches.
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="punches"
      class="elevation-1"
    ></v-data-table>
  </div>
</template>

<script>
import fb from "@/main";
import { mapState } from "vuex";
import myJobSites from "@/components/MyJobSites";

export default {
  components: {
    myJobSites: myJobSites,
  },
  data: () => {
    return {
      punches: [],
      showManaulWarning: false,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "Punch",
          align: "start",
          sortable: false,
          value: "direction",
        },
        {
          text: "Job Site",
          align: "start",
          sortable: false,
          value: "jobSite",
        },
        {
          text: "Source",
          align: "start",
          sortable: false,
          value: "source",
        },
        {
          text: "Timestamp",
          align: "start",
          sortable: false,
          value: "datetime",
        },
      ],
    };
  },
  async created() {
    if (!this.employees.length) {
      await this.$store.dispatch("getEmployees", fb);
    }
  },
  computed: {
    ...mapState(["user", "employees"]),
    allEmployees: function() {
      return this.employees.map((e) => {
        return {
          ...e,
        };
      });
    },
  },
  mounted: async function() {
    const today = new Date();
    const lookbackDate = new Date(today);
    const daysAgo = 7;
    lookbackDate.setDate(lookbackDate.getDate() - daysAgo);

    const punRes = await fb.db
      .collection("punchRecords")
      .where("createdBy", "==", this.user.uid)
      .where("time", ">", lookbackDate)
      .orderBy("time", "desc")
      .get();

    // get employee punches
    const punches = [];
    const jobSiteIds = [];
    const dates = [];
    punRes.forEach((r) => {
      const obj = r.data();
      if (jobSiteIds.indexOf(obj.jobSite) === -1) jobSiteIds.push(obj.jobSite);
      obj.datetime = new Date(obj.time.seconds * 1000).toLocaleString("en-US");

      const date = new Date(obj.time.seconds * 1000).toLocaleDateString(
        "en-US"
      );
      if (dates.indexOf(obj.date) === -1) dates.push(obj.date);

      punches.push(obj);
    });

    if (!punches.length) {
      return;
    }

    // unique list of jobsites
    const jobSiteMap = {};
    let i = 0;
    while (i < jobSiteIds.length) {
      const res = await fb.db
        .collection("jobSites")
        .doc(jobSiteIds[i])
        .get();
      const obj = res.data();
      jobSiteMap[jobSiteIds[i]] = obj;
      i++;
    }

    punches.forEach((punch) => {
      const employee =
        this.allEmployees.find((e) => e.docId === punch.employee) || {};
      punch.name = `${employee.firstName} ${employee.lastName}`;
      punch.jobSite = `${(jobSiteMap[punch.jobSite] || {}).street} (${
        (jobSiteMap[punch.jobSite] || {}).jobId
      })`;
    });

    // show warning if more manaul punches than camera punches
    const manualPunches = punches.filter((p) => p.source === "manual");
    const cameraPunches = punches.filter((p) => p.source === "camera");
    this.showManaulWarning =
      manualPunches.length > cameraPunches && dates.length > 3;

    this.punches = punches;
  },
};
</script>
